module.exports = __webpack_public_path__ + "img/chystam-party-item-circle-small.a6d6ba3.svg";